import { AuthModal } from "../index";
import { Button } from "shared";
import "./WelcomeSuccession.scss";
import { useState } from "react";
import { queryClient } from "App";

const WelcomeSuccession: React.FC = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleLoginClick = async () => {
    if (isRefreshing) return;
    setIsRefreshing(true);

    await queryClient.invalidateQueries({
      predicate: (q) =>
        Array.isArray(q.queryKey) &&
        q.queryKey.includes("succession") &&
        q.queryKey.includes("settings"),
    });

    setIsRefreshing(false);
  };

  return (
    <AuthModal
      heading={"Witamy w Sukcesji!"}
      paragraph={
        <>
          <p>Twoje konto zostało utworzone pomyślnie</p>
          <p>
            Możesz się juz zalogować na swoje konto i dodać pliki oraz
            sukcesora.
          </p>
        </>
      }
    >
      <div className="successors__login">
        <Button
          label={"Zaloguj się"}
          styleType="primary"
          type="button"
          onClick={handleLoginClick}
          className="successor-entry-code__confirm"
          disabled={isRefreshing}
        />
      </div>
    </AuthModal>
  );
};

export default WelcomeSuccession;
